export enum PortalDisplayPage {
    ProductList = 1,
    ProductDetail = 2,
    ShoppingCart = 3,
    Shipping = 4,
    Delivery = 5,
    Payment = 6,
    CartSummary = 7,
    OrderSummary = 8
}
